export var AuthInfoFailCode;
(function (AuthInfoFailCode) {
    AuthInfoFailCode["NoNidIdNo"] = "AUTH_10";
    AuthInfoFailCode["NoApiResult"] = "AUTH_11";
    AuthInfoFailCode["NotAgree"] = "AUTH_12";
    AuthInfoFailCode["Leave"] = "AUTH_20";
    AuthInfoFailCode["Dormancy"] = "AUTH_21";
    AuthInfoFailCode["TransactionStop"] = "AUTH_30";
    AuthInfoFailCode["NotNaverMember"] = "AUTH_40";
})(AuthInfoFailCode || (AuthInfoFailCode = {}));
export const AuthInfoSuccessCode = 'AUTH_00';
export const AuthInfoErrorCode = 'AUTH_99';
export const createAuthSuccessResponse = (response) => response;
export const createAuthFailResponse = (response) => response;
export const createAuthErrorResponse = (response) => response;
